import { render, staticRenderFns } from "./c-loading-test@.vue?vue&type=template&id=a66b5c46&"
import script from "./c-loading-test@.vue?vue&type=script&lang=ts&"
export * from "./c-loading-test@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports